import { otpHost, mscHost } from './../config/env.conf';
import ViewWrapper from 'components/view-wrapper/view-wrapper.vue';
import InnerFrame from 'components/inner-frame/inner-frame';
const bizLine = 'ticket';
const baseUrl = `${otpHost}/#/${bizLine}/`;
const bizVerifyPrefix = baseUrl + 'voucher/';
const productPrefix = baseUrl + 'product/'
const orderPrefix = baseUrl + 'order/';
const promotionPrefix = baseUrl + 'promotion/';
let mscBase = `${mscHost}//msc/fe/index.html#/`;
import RouteBuilder from './routeBuilder';
import Comment from 'views/comment/list/Main.vue';
const ticketBuiler = new RouteBuilder(bizLine, ViewWrapper, InnerFrame);
let comment = RouteBuilder.buildReviewList(ticketBuiler, Comment);
let commentDetail = RouteBuilder.buildReviewDetail(ticketBuiler, Comment);
import AcademyHome from 'views/academy/HomePage.vue';
let xgxy = RouteBuilder.buildXAXY(ticketBuiler, AcademyHome);
let gzzx = RouteBuilder.buildGZZX(ticketBuiler);
import { getMscSrc } from './routerHelper';

function getBizName(name) {
    return bizLine + name;
}

export default [{
    name: getBizName('home'),
    path: '',
    component: require('views/homepage/homepage.vue'),
    meta: {
        title: '首页',
        icon: 'turbo-ui-home'
    }
}, {
    name: getBizName('voucher'),
    path: 'voucher',
    component: ViewWrapper,
    children: [{
        name: getBizName('voucherVerify'),
        path: 'verify',
        component: InnerFrame,
        meta: {
            src: `${bizVerifyPrefix}verify`,
            title: '验券'
        }
    }, {
        name: getBizName('voucherRevert'),
        path: 'revert',
        component: InnerFrame,
        meta: {
            src: `${bizVerifyPrefix}revert`,
            title: '撤销验券'
        }
    }, {
        name: getBizName('voucherHistory'),
        path: 'history',
        component: require('views/ticket/verify/history/Main.vue'),
        redirect: { name: getBizName('singleProgram') },
        meta: {
            title: '验券历史'
        },
        children: [{
            name: getBizName('singleProgram'),
            path: 'singleProgram',
            component: require('views/ticket/verify/history/pages/singleProgramConsumption.vue'),
            meta: {
                noAuth: true,
                activeName: getBizName('voucherHistory')
            }
        },
        {
            name: getBizName('allProgram'),
            path: 'allProgram',
            component: require('views/ticket/verify/history/pages/allProgramConsumption.vue'),
            meta: {
                noAuth: true,
                activeName: getBizName('voucherHistory')
            }
        },
        {
            name: getBizName('detailProgram'),
            path: 'detail/:dealName/:dealId/:useTimeStart',
            component: require('views/ticket/verify/history/pages/detailConsumption.vue'),
            meta: {
                notMenu: true,
                noAuth: true
            }
        }
        ]
    }, {
        name: getBizName('voucherPhone'),
        path: 'phone',
        redirect: { name: getBizName('app') },
        meta: {
            title: '手机验券'
        },
        component: require('views/ticket/verify/phone/Main.vue'),
        children: [{
            name: getBizName('phone'),
            path: 'phone',
            component: require('views/ticket/verify/phone/pages/phoneVerify.vue'),
            meta: {
                noAuth: true,
                notMenu: true,
                activeName: getBizName('voucherPhone')
            }
        }, {
            name: getBizName('app'),
            path: 'app',
            component: require('views/ticket/verify/phone/pages/appVerify.vue'),
            meta: {
                noAuth: true,
                notMenu: true,
                activeName: getBizName('voucherPhone')
            }
        }]
    }],
    meta: {
        title: '验券管理',
        icon: 'turbo-ui-ticket'
    }
}, {
    name: getBizName('product'),
    path: 'product',
    component: ViewWrapper,
    children: [{
        name: getBizName('newProduct'),
        path: 'new',
        component: InnerFrame,
        meta: {
            title: '新建产品',
            src: `${productPrefix}new`
        }
    }, {
        name: getBizName('listProduct'),
        path: 'list',
        component: InnerFrame,
        meta: {
            title: '产品列表',
            src: `${productPrefix}list?third=1`
        }
    }, {
        name: getBizName('directProduct'),
        path: 'direct',
        component: InnerFrame,
        meta: {
            title: '直连产品锁定',
            src: `${productPrefix}direct`
        }
    }, {
        name: getBizName('listCertificate'),
        path: 'list-certificate',
        component: InnerFrame,
        meta: {
            title: '授权书管理',
            src: `${productPrefix}list-certificate`
        }
    }, {
        name: getBizName('directSignTicketProductList'),
        path: 'direct-list',
        component: InnerFrame,
        meta: {
            title: '产品列表',
            src: `${productPrefix}direct-list`
        }
    }, {
        name: getBizName('directSignTicketNewProduct'),
        path: 'direct-new-product',
        component: InnerFrame,
        meta: {
            title: '添加新产品',
            src: `${productPrefix}direct-new-product`
        }
    }, {
        name: getBizName('directSignTicketNewPull'),
        path: 'direct-new-pull',
        component: InnerFrame,
        meta: {
            title: '拉取新产品',
            src: `${productPrefix}direct-new-pull`
        }
    },
    {
        name: getBizName('misCreateTicket'),
        path: '/mis/ticket/product/item/:id?',
        redirect: { name: 'misCreateTicket' },
        meta: {
            notMenu: false
        }
    },
    {
        name: getBizName('bizCreateTicket'),
        path: 'item/:id?',
        redirect: { name: 'bizCreateTicket' },
        meta: {
            notMenu: false
        }
    }
    ],
    meta: {
        title: '产品管理',
        icon: 'turbo-ui-setting'
    }
}, {
    name: getBizName('order'),
    path: 'order',
    component: ViewWrapper,
    children: [{
        name: getBizName('ticketOrderList'),
        path: 'ticket',
        component: InnerFrame,
        meta: {
            title: '订单列表',
            src: orderPrefix + 'ticket'
        }
    }, {
        name: getBizName('ticketOrderReserve'),
        path: 'reserve-ticket',
        component: InnerFrame,
        meta: {
            title: '待出票订单',
            src: orderPrefix + 'reserve-ticket'
        }
    }, {
        name: getBizName('OrderRefund'),
        path: 'refund-ticket',
        component: InnerFrame,
        meta: {
            title: '申诉退款订单',
            src: orderPrefix + 'refund-ticket'
        }
    }],
    meta: {
        title: '订单管理',
        icon: 'assignment'
    }
}, {
    name: getBizName('finance'),
    path: 'finance',
    component: ViewWrapper,
    children: [{
        name: getBizName('financeaytrace'),
        path: 'paytrace',
        component: InnerFrame,
        meta: {
            title: '查看对账单',
            src: getMscSrc(`${mscBase}statement/travel/`),
            withPadding: true
        }
    }, {
        name: getBizName('financeStatement'),
        path: 'statement',
        component: InnerFrame,
        meta: {
            title: '付款记录',
            src: getMscSrc(`${mscBase}paytrace/travel/tickets`),
            withPadding: true
        }
    },
    {
        name: getBizName('financePre'),
        path: 'pre',
        component: InnerFrame,
        meta: {
            title: '预付款结算',
            src: getMscSrc(`${mscBase}statement/ap-travel/tickets`),
            withPadding: true
        }
    },
    {
        name: getBizName('invoiceManage'),
        path: 'invoice',
        component: InnerFrame,
        meta: {
            title: '发票管理',
            src: getMscSrc(`${mscHost}/msc/biz/travel/invoice/queryPartnerInvoiceModel?buzParty=TRAVEL&bizline=tickets&sellType=tickets`),
            withPadding: true
        }
    }, {
        name: getBizName('invoiceAnswer'),
        path: 'answer',
        component: InnerFrame,
        meta: {
            title: '财务问答',
            src: getMscSrc(`${mscBase}question/travel/`),
            withPadding: true
        }
    }
    ],
    meta: {
        title: '财务管理',
        icon: 'turbo-ui-money'
    }
}, {
    name: getBizName('reporter'),
    path: 'reporter',
    component: ViewWrapper,
    children: [{
        name: getBizName('reporterIndexData'),
        path: 'indexData',
        component: require('views/dataPlatform/menpiao/indexData/Main.vue'),
        meta: {
            title: '数据概览'
        }
    }, {
        name: getBizName('reporterOperations'),
        path: 'operations',
        component: require('views/dataPlatform/menpiao/operateData/Main.vue'),
        meta: {
            title: '经营分析'
        }
    }, {
        name: getBizName('reporterProjects'),
        path: 'projects',
        component: require('views/dataPlatform/menpiao/productData/Main.vue'),
        meta: {
            title: '商品分析'
        }
    },
    {
        name: getBizName('reporterTransactionData'),
        path: 'transaction',
        component: require('views/dataPlatform/menpiao/transactionData/Main.vue'),
        meta: {
            title: '交易分析'
        }
    },
    {
        name: getBizName('customeResource'),
        path: 'customerResource',
        component: require('views/newGtyDataCenter/customerSourceAnalyse.vue'),
        meta: {
            title: '景区客源分析',
            type: bizLine
        }
    }, {
        name: getBizName('reporterReserveTicket'),
        path: 'operations',
        component: require('views/dataCenter/operationData.vue'),
        meta: {
            title: '预约券量',
            type: bizLine
        }
    }
    ],
    meta: {
        title: '数据分析',
        icon: 'turbo-ui-bargraph'
    }
}, {
    name: getBizName('promotion'),
    path: 'promotion',
    component: ViewWrapper,
    children: [{
        name: getBizName('flowInvestList'),
        path: 'flow-invest-list',
        component: InnerFrame,
        meta: {
            title: '流量招商活动',
            src: promotionPrefix + 'flow-invest-list'
        }
    }, {
        name: getBizName('selfPromotionDealList'),
        path: 'deal-list',
        component: InnerFrame,
        meta: {
            title: '自助活动创建',
            src: promotionPrefix + 'deal-list'
        }
    },
    {
        name: getBizName('selfPromotionList'),
        path: 'self-promotion-list',
        component: InnerFrame,
        meta: {
            title: '自助活动查询',
            src: promotionPrefix + 'self-promotion-list'
        }
    }
    ],
    meta: {
        title: '营销中心',
        icon: 'turbo-ui-fire'
    }
}, comment, commentDetail, xgxy, gzzx];


// WEBPACK FOOTER //
// ./src/router/router.ticketng.js